<template>
  <svg class="logo-marque" data-name="Logo Marque" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.59 19.76"><path style="fill:none;" d="M7.8.5a7.37,7.37,0,0,1,7.3,7.43V19.26H.5V7.93A7.37,7.37,0,0,1,7.8.5"/>
  </svg>
</template>

<script>
export default {
  name: 'logoMarque'
}
</script>

<style lang="scss">
.logo-marque{
  stroke:inherit;
  overflow:visible;
}
</style>



// WEBPACK FOOTER //
// LogoMarque.vue?78704ffe